import { getBuildEnv } from '../settings/envGuard'

export const AI_CLERK_UPLOAD_DEMO_VARIANT = {
  /** 现网对照组：上传区右侧保留三条权益说明文案。 */
  CONTROL: 'control',
  /** 实验组：上传区右侧换成「照片→填好的文件」活演示。 */
  LIVE_DEMO: 'live_demo'
} as const

export type AiClerkUploadDemoVariant =
  (typeof AI_CLERK_UPLOAD_DEMO_VARIANT)[keyof typeof AI_CLERK_UPLOAD_DEMO_VARIANT]

/** 将神策实验值收敛到前端支持的枚举，异常值回退到现网对照组。 */
export function normalizeAiClerkUploadDemoVariant(
  value: unknown
): AiClerkUploadDemoVariant {
  return value === AI_CLERK_UPLOAD_DEMO_VARIANT.LIVE_DEMO
    ? AI_CLERK_UPLOAD_DEMO_VARIANT.LIVE_DEMO
    : AI_CLERK_UPLOAD_DEMO_VARIANT.CONTROL
}

const PREVIEW_ENVIRONMENTS = new Set(['local', 'test', 'staging'])

/**
 * 读取上传区活演示的验收预览分组。
 *
 * 与 `readAiEducationPreviewMode` 同一套约定：只在非生产构建生效，
 * 避免生产用户通过 URL 绕过实验分组。
 *
 * @param search - 当前地址的 query string
 * @param buildEnv - 当前构建环境，默认读取编译期环境变量
 * @returns 合法预览分组；生产环境或非法值返回 null
 *
 * @example
 * ```ts
 * readAiClerkUploadDemoPreviewVariant('?ai_upload_demo_preview=live_demo', 'local')
 * // 'live_demo'
 * ```
 */
export function readAiClerkUploadDemoPreviewVariant(
  search: string,
  buildEnv: string = getBuildEnv()
): AiClerkUploadDemoVariant | null {
  if (!PREVIEW_ENVIRONMENTS.has(buildEnv)) return null
  const value = new URLSearchParams(search).get('ai_upload_demo_preview')
  return value === AI_CLERK_UPLOAD_DEMO_VARIANT.CONTROL ||
    value === AI_CLERK_UPLOAD_DEMO_VARIANT.LIVE_DEMO
    ? value
    : null
}
